import { render } from "./CasesComponent.vue?vue&type=template&id=7e49b934&scoped=true"
import script from "./CasesComponent.vue?vue&type=script&lang=js"
export * from "./CasesComponent.vue?vue&type=script&lang=js"

import "./CasesComponent.vue?vue&type=style&index=0&id=7e49b934&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e49b934"]])

export default __exports__